<template>
    <div>
        <h1>Register Team</h1>
    </div>
</template>

<script>
export default {
  name: 'registerTeam',
  data() {
    return {};
  },
};
</script>


// WEBPACK FOOTER //
// src/components/views/RegisterTeam.vue